import { useQuery } from "@tanstack/react-query";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { backendService } from "../../../services/backend.service";
import type { NurseData, NursesToRemoveParams } from "../../../utils/models";

export const useNurseRemoval = (params: NursesToRemoveParams) => {
	const { showErrorSnackbar, isHospitalDemo } = useHospitalData();

	return useQuery<NurseData[]>({
		// Keyed by department AND date: the list is per-date, so a date change must fetch its own list instead of
		// showing the previous date's staff (gcTime 0 only drops the cache once nothing observes it).
		queryKey: ["nurses_to_remove", params.departmentId, params.date.toISODate()],
		queryFn: async () => {
			const response = await backendService.getNurseToRemove(params);
			return response.data;
		},
		throwOnError: (error: unknown) => {
			showErrorSnackbar("Failed to find nurses to remove", {}, error);
			return false;
		},
		gcTime: 0,
		enabled: !isHospitalDemo,
	});
};
